import React from "react";
import { BorderNav } from "../Style/Styled";

export default function Border() {
  return <BorderNav />;
}
